import { defineComponent as _defineComponent } from 'vue'
import { ref, computed,
  onMounted, reactive, getCurrentInstance } from "vue";
import {RegistrationSuperShortModel} from "@/views/pages/auth/registration";
import GuestFormGroup from "@/components/forms/guest/GuestFormGroup.vue";
import RegistrationCaptcha from "@/views/pages/auth/reg/RegistrationCaptcha.vue";
import  "primevue/resources/primevue.min.css";
import {useRoute, useRouter} from "vue-router/composables";
import Cookies from 'js-cookie';
import router from "@/router";

declare function ym(a, b, c): void;
// declare function $t(a): string;


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationSuperShortPage',
  props: {
  from: {
    type: String,
    required: false,
    default: null
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();



const registrationQueryValues = computed(() => {
  return {
    refCode: route.query.from || route.params.from || Cookies.get('ReferralCode') || '',
    inviteCode: route.query.invite || '',
    referrer: Cookies.get('TheReferer') || '',
    category: route.query.a || '',
  }
})

const model = reactive(new RegistrationSuperShortModel());
const redirecting = ref(false);

const isModelDisabled = computed(() => {
  return model.submitstate.isLoading || redirecting.value;
})

const isPromocodeDisabled = computed(() => {
  return isModelDisabled.value || registrationQueryValues.value.refCode?.length > 0;
})

const locale = computed(() => {
  return getCurrentInstance()?.proxy?.$i18n.locale || 'ru';
})

const isRegisterDisabled = computed(() => {
  return isModelDisabled.value
    || !model.values.acceptedAgreement;
})



const yandexMetrikaRegisterFinal = (usertype) => {

  try {

    if (typeof ym === 'function') {
      if (usertype === 'INDIVIDUAL') {
        ym(55378108,'reachGoal','REG_PERSONAL')
      }
      if (usertype === 'LEGAL') {
        ym(55378108,'reachGoal','REG_BUSINESS')
      }
    }
  } catch (e) {

  }
}

const regCaptcha = ref(null);

const submit = () => {
  model.errors.clear();

  model.values = {...model.values, ...registrationQueryValues.value};

  model.submit().then(() => {
    redirecting.value = true;
    // yandexMetrikaRegisterFinal(model.values.userType);

    setTimeout(() => {
      window.location.href = '/regconfirm';
    }, 1000);
  }).catch((e) => {
    regCaptcha.value?.forceUpdate();
    model.values.captchaCode = '';
  })
}

onMounted(() => {
  // if (!registrationQueryValues.value.category
  //     || !registrationQueryValues.value.category.length
  //     i!registrationQueryValues.value.refCode
  //     || !registrationQueryValues.value.refCode.length) {
  //
  //   const qs = new URLSearchParams(window.location.search);
  //   const url = '/reg?' + qs.toString();
  //   router.push(url).then(() => {
  //     window.location.reload();
  //   })
  // }

  model.values = {...model.values, ...registrationQueryValues.value};
})

return { __sfc: true,route, props, registrationQueryValues, model, redirecting, isModelDisabled, isPromocodeDisabled, locale, isRegisterDisabled, yandexMetrikaRegisterFinal, regCaptcha, submit, ref, computed, onMounted, reactive, getCurrentInstance, RegistrationSuperShortModel, GuestFormGroup, RegistrationCaptcha, useRoute, useRouter, Cookies, router }
}

})